export default  {
    component: 'customer',
    name: 'customer',
    fields: [
        {
            name: 'Customer ID',
            param: 'cust_id',
            type: 'number',
            required: true,
            identifier: true,
            autoIncrement: true,
            description: `Customer ID should be unique. Same ID should be passed at plant level configuration`
          },
          {
            name: 'Customer Name',
            param: 'cust_name',
            type: 'text',
            description: `Same customer name should not be created`
          },
          {
            name: 'Country',
            param: 'country',
            type: 'text'
          },
          {
            name: 'State',
            param: 'state',
            type: 'text'
          },
          {
            name: 'Address',
            param: 'address',
            type: 'text'
          },
          {
            name: 'Contact',
            param: 'contact',
            type: 'number'
          },
          {
            name: 'Logo Address',
            param: 'logo_address',
            type: 'number'
          }

    ]
  }
